module.exports = __webpack_public_path__ + "img/act_pro_img4s_03.f4a074e8.png";